module.exports = "<div id=\"cover-spin\"></div>\r\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/dealer-sign-up/components/wait/dealer-sign-up-wait.component.html
// module id = ./src/app/dealer-sign-up/components/wait/dealer-sign-up-wait.component.html
// module chunks = main